import { orchestrator } from 'satcheljs';
import { setForcedFlexibleDayView } from 'owa-calendar-layout';
import { CalendarViewTypeEnum, CalendarViewTypeEnumToDateRangeType } from 'owa-calendar-view-type';
import { processDateRangeTypeOrDayRangeChange } from '../actions/processDateRangeTypeOrDayRangeChange';

orchestrator(setForcedFlexibleDayView, actionMessage => {
    if (actionMessage.forcedFlexibleDayView) {
        processDateRangeTypeOrDayRangeChange(
            CalendarViewTypeEnumToDateRangeType(CalendarViewTypeEnum.Daily),
            6
        );
    } else {
        processDateRangeTypeOrDayRangeChange(
            CalendarViewTypeEnumToDateRangeType(CalendarViewTypeEnum.Weekly),
            1
        );
    }
});
